import UserNotificationsApi from '../../../services/UserNotificationsApi';
import * as actions from './actions';

const getUserNotifications = () => dispatch => {
  dispatch(actions.fetchUserNotifications());
  return UserNotificationsApi.getUserNotifications()
    .then(userNotifications =>
      userNotifications.map(notification => {
        return {
          ...notification,
          notificationData: JSON.parse(notification.notificationData),
          theme: notification.theme.toUpperCase()
        };
      })
    )
    .then(normalizedUserNotifications => {
      dispatch(actions.fetchUserNotificationsSuccess(normalizedUserNotifications));
    })
    .catch(error => {
      dispatch(actions.fetchUserNotificationsError(error));
    });
};

const dismissUserNotification = notificationId => dispatch => {
  dispatch(actions.dismissUserNotification());
  return UserNotificationsApi.dismissUserNotification(notificationId)
    .then(() => {
      dispatch(actions.dismissUserNotificationSuccess());
    })
    .catch(error => {
      dispatch(actions.dismissUserNotificationError(error));
    });
};

export { getUserNotifications, dismissUserNotification };
